"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.sourceType.group': 'Group',
    'whatsapp.sourceType.dm': 'DM',
    'whatsapp.sourceType.email': 'Email',
};
